<template>
  <router-link tag="div" :to="{ name: 'Participant details', params: { user: user.id } }" class="attendee-block block">
    <Avatar size="sm" :src="user.avatar" :online="user.online" />
    <div class="name">{{ $localized(user.localized_name, user.first_name) }} {{ $localized(user.localized_surname, user.last_name) }}</div>
    <Role :role="user.role" />
    <Location hide-flag :country="user.country" />
  </router-link>
</template>

<script>
import Avatar from '@/components/user/Avatar'
import Role from '@/components/user/Role'
import Location from '@/components/user/Location'
export default {
  name: 'Attendee',
  components: { Location, Role, Avatar },
  props: {
    user: Object,
  },
}
</script>

<style lang="scss">
.attendee-block {
  @include flexCenter;
  flex-direction: column;
  padding: 24px 24px 17px;
  background: #ffffff;
  border-bottom: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s;

  @include PC {
    padding: 30px 40px 22px 40px;
  }

  @include mobile {
    box-shadow: 0 4.50738px 21.4101px rgba(0, 0, 0, 0.06);
  }

  .user-role {
    color: $dark;
  }

  &:hover {
    border-bottom-color: $primary;

    .user-role {
      color: $primary;
    }
  }

  .avatar {
    width: 70px;
    height: 70px;
    border-radius: 10px;
    margin-bottom: 20px;

    @include PC {
      width: 84px;
      height: 84px;
      border-radius: 10px;
      margin-bottom: 18px;

      .online-status-dote {
        width: 11px;
        height: 11px;
      }
    }
  }

  .name {
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    color: #474747;
    text-align: center;

    @include mobile {
      font-weight: 700;
      font-size: 15px;
      line-height: 16px;
      margin-bottom: 10px;
      max-width: 95px;
    }
  }

  .user-role {
    margin-bottom: 14px;

    @include PC {
      margin-bottom: 21px;
    }
  }

  .user-location span {
    font-weight: 400;
    font-size: 12px;
    line-height: 147.5%;
    color: #d0d0d0;
  }
}
</style>
